/** Eternal City copy, pt-BR. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityPtBR: Record<string, string> = {
  'city.seoDescription': 'Entrem numa cidade viva. Todos seguem um dia-a-dia. Segue-os, converse com eles, e passe um dia com as pessoas que vivem sem você.',
  'city.intro': 'Uma cidade viva. Todos aqui mantêm uma rotina diária, e o tempo passa enquanto você joga.',
  'city.back': 'De volta ao globo',
  'city.connecting': 'Abrindo os portões da cidade...',
  'city.reconnecting': 'Perdi o fio.',
  'city.offline': 'A cidade está fora de alcance neste momento.',
  'city.signinTitle': 'Inscreva-se para entrar',
  'city.signinBody': 'O seu lugar na cidade, o seu diário e as pessoas que você conheceu são guardados para a sua conta.',
  'city.signinCta': 'Inscrever-se',
  'city.privacy': 'Como tratamos estes dados: Política de privacidade',
  'city.blocked': 'A cidade não está aberta a esta conta neste momento.',
  'city.openElsewhere': 'Esta cidade está aberta noutra guia.',
  'city.canvasLabel': 'Mapa isométrico de {city}. Usa as listas ao lado para falar, andar e olhar ao redor.',
  'city.hint': 'Clique no chão para andar, ou clique em uma pessoa para falar.',
  'city.holiday': 'Hoje: {name}',
  'city.here': 'Estás em {place}.',
  'city.commons.empty': 'Este é um espaço compartilhado, e nenhum outro viajante está aqui agora.',
  'city.commons.here.one': 'Este é um espaço compartilhado, e outro viajante está aqui.',
  'city.commons.here.other': 'Este é um espaço compartilhado, e {count} Outros viajantes estão aqui.',
  'city.commons.peer': 'um companheiro de viagem',
  'city.crowd.name': 'Pessoas da cidade',
  'city.travel.ride': 'Caminhar para {place} (cerca de {n} Minutos)',
  'city.wares.now': 'Agora é claro: {list}',
  'city.wares.none': 'Não há nada disponível a esta hora.',
  'city.wares.few': '{name} (alguns a esquerda)',
  'city.wares.last': '{name} (a última)',
  'city.places': 'Vai a um sítio.',
  'city.goPlace': 'Vai para {place}',
  'city.dialogueAnnounce': 'As escolhas são anunciadas à medida que aparecem.',
  'city.people': 'Quem está por perto',
  'city.peopleNone': 'Ninguém à vista.',
  'city.talk': 'Fala',
  'city.goto': 'Passa-te por aqui.',
  'city.away': '{n} passos de distância',
  'city.scenes': 'Acontece por perto.',
  'city.watch': 'Junte-se .',
  'city.props': 'Olhem por aqui.',
  'city.examine': 'Olhem.',
  'city.open': 'Abre',
  'city.take': 'Tome-a.',
  'city.menu.open': 'Abre {thing}',
  'city.menu.take': 'Tome o que está lá dentro. {thing}',
  'city.menu.walkToThing': 'Caminha até lá. {thing}',
  'city.dialogue': 'Conversação',
  'city.close': 'Aproximado',
  'city.leave': 'Deixe a conversa',
  'city.menu.talk': 'Fala com {name}',
  'city.menu.walkTalk': 'Passa-te para cá. {name}',
  'city.menu.walkTo': 'Caminha até lá. {name}',
  'city.menu.walkHere': 'Anda por aqui.',
  'city.menu.swimHere': 'Nata aqui.',
  'city.menu.rowHere': 'Entra aqui.',
  'city.mount.down': 'Baixa-te. {name}',
  'city.companion.home': 'Enviar {name} casa',
  'city.rumours.title': 'Tabela de rumores',
  'city.rumours.none': 'Ainda não se ouviu nada, estamos perto dos habitantes da cidade a falar juntos, na taberna acima de tudo, e o que dizem está aqui preso.',
  'city.rumours.said': 'Disse {name}',
  'city.greet.title': 'Conhecido por nome',
  'city.greet.callMe': 'Como os habitantes da cidade te chamam',
  'city.greet.placeholder': 'O teu nome.',
  'city.greet.none': 'Ninguém te conhece ainda. Parem e falem com alguém, e na próxima vez eles te cumprimentarão pelo nome.',
  'city.greet.morning.0': 'De manhã. {name}!',
  'city.greet.morning.1': 'Bom dia para ti. {name}.',
  'city.greet.morning.2': 'Levanta-te cedo. {name}?',
  'city.greet.afternoon.0': 'Boa tarde. {name}.',
  'city.greet.afternoon.1': 'Bom dia. {name}!',
  'city.greet.afternoon.2': 'Bem conhecido outra vez. {name}.',
  'city.greet.evening.0': 'À noite, {name}.',
  'city.greet.evening.1': 'Boa noite. {name}!',
  'city.greet.evening.2': 'Fora de casa, {name}?',
  'city.greet.night.0': 'É tarde para sair. {name}.',
  'city.greet.night.1': 'Cuidado com a escuridão. {name}.',
  'city.greet.night.2': 'Ainda por aí. {name}?',
  'city.greet.morning.0.anon': 'Bom dia, amigo!',
  'city.greet.morning.1.anon': 'Bom dia para ti.',
  'city.greet.morning.2.anon': 'Acorda cedo, amigo?',
  'city.greet.afternoon.0.anon': 'Boa tarde, amigo.',
  'city.greet.afternoon.1.anon': 'Bom dia para ti!',
  'city.greet.afternoon.2.anon': 'Bem conhecido.',
  'city.greet.evening.0.anon': 'Noite, amigo.',
  'city.greet.evening.1.anon': 'Boa noite!',
  'city.greet.evening.2.anon': 'Fora de casa, amigo?',
  'city.greet.night.0.anon': 'É tarde para sair, amigo.',
  'city.greet.night.1.anon': 'Cuidado com a escuridão.',
  'city.greet.night.2.anon': 'Ainda cá, amigo?',
  'city.market.title': 'Tabela de mercado',
  'city.market.shut': 'Não há nada disponível neste momento.',
  'city.market.later': 'Mais tarde hoje:',
  'city.market.am': '{n} pela manhã.',
  'city.market.pm': '{n} à tarde',
  'city.market.eve': '{n} à noite.',
  'city.garden.title': 'Parcelhas de jardim',
  'city.garden.tend': '- Cuidado com a trama.',
  'city.garden.tended': 'Tiras algumas ervas daninhas e regas o terreno.',
  'city.garden.already': 'Você já cuidou desta trama hoje.',
  'city.garden.tendedNote': 'hoje',
  'city.garden.arrive': 'A Comissão {crop} Aqui estão . {stage}.',
  'city.garden.crop.herbs': 'Ervas',
  'city.garden.crop.apples': 'árvores de maçã',
  'city.garden.crop.kitchen': 'vegetais de cozinha',
  'city.garden.crop.cabbages': 'Arroz e feijão',
  'city.garden.crop.wheat': 'Campos de trigo',
  'city.garden.stage.bare': 'Desnudos para o inverno',
  'city.garden.stage.sown': 'sementes recém-sementadas',
  'city.garden.stage.sprouting': 'germinando',
  'city.garden.stage.growing': 'crescendo bem',
  'city.garden.stage.flowering': 'em flor',
  'city.garden.stage.ripe': 'maduro e pronto',
  'city.garden.stage.harvested': 'colhidos para o ano',
  'city.fish.title': 'Pesca',
  'city.fish.cast': 'Lança uma linha',
  'city.fish.go': 'Vai-te embora.',
  'city.fish.here': 'Um bom local de pesca.',
  'city.fish.casting': 'Faz uma fila e espera.',
  'city.fish.caught': 'Alguma coisa morde. {fish}.',
  'city.fish.got.boot': 'Encosto-te numa bota velha e atira-a de volta.',
  'city.fish.got.weed': 'Só erva do rio desta vez.',
  'city.fish.got.nothing': 'Nada morde, a água guarda os segredos.',
  'city.fish.casts': '{n} lançamentos até agora',
  'city.fish.none': 'Os peixes mordem melhor ao amanhecer e ao anoitecer, e mais na primavera e no outono.',
  'city.fish.spot.bank': 'margem do rio',
  'city.fish.spot.jetty': 'Jetty',
  'city.fish.spot.bridge': 'ponte de moinho',
  'city.fish.name.perch': 'uma perca',
  'city.fish.name.roach': 'uma barata',
  'city.fish.name.trout': 'uma truta',
  'city.fish.name.eel': 'uma enguia',
  'city.fish.name.pike': 'uma picada',
  'city.fish.name.carp': 'uma carpa',
  'city.fish.name.minnow': 'um minnow',
  'city.fish.name.crayfish': 'um caranguejo',
  'city.fish.name.boot': 'uma bota velha',
  'city.fish.name.weed': 'Ervas daninhas',
  'city.fish.name.nothing': 'Não há nada.',
  'city.lost.title': 'Perdidos e encontrados',
  'city.lost.none': 'As pessoas deixam as coisas nos mercados, na praça e em outros lugares movimentados.',
  'city.lost.whose': 'pertence a {name}',
  'city.lost.find': 'Encontrar {name}',
  'city.lost.spot': 'Há algo no chão aqui: {thing}',
  'city.lost.pick': 'Atira-me. {thing}',
  'city.lost.picked': 'Tu atendes. {thing}. Parece que pertence a {name}.',
  'city.lost.give': 'Dá-me {thing} de volta para {name}',
  'city.lost.thanks': '{name} É feliz por ter {thing} De volta.',
  'city.lost.thing.glove': 'Uma luva perdida',
  'city.lost.thing.keys': 'um anel de chaves',
  'city.lost.thing.locket': 'Um pequeno medalhão',
  'city.lost.thing.toy': 'um brinquedo de madeira',
  'city.lost.thing.scarf': 'um lenço de lã',
  'city.lost.thing.purse': 'uma bolsa vazia',
  'city.lost.thing.spectacles': 'um par de óculos',
  'city.lost.thing.letter': 'uma carta dobrada',
  'city.lost.thing.ribbon': 'uma fita de cabelo',
  'city.lost.thing.pipe': 'um tubo de argila',
  'city.records.title': 'Registros municipais',
  'city.records.peak': 'O mais ocupado hoje em {time}, com {n} Os habitantes da cidade estão por aí.',
  'city.records.now': 'Nesta hora: {out} Fora, fora. {home} Em casa.',
  'city.records.busiest': 'Quarto mais ocupado: {district}.',
  'city.records.outTitle': 'Os habitantes da cidade estão fora, por hora.',
  'city.records.seenTitle': 'Pessoas que viste ao teu redor, por hora.',
  'city.a11y.title': 'Acessibilidade',
  'city.a11y.text': 'Tamanho do texto',
  'city.a11y.size1': 'Normal',
  'city.a11y.size125': 'Grande',
  'city.a11y.size15': 'Maior',
  'city.a11y.stillOff': 'Reduzir o movimento',
  'city.a11y.stillOn': 'Moção reduzida',
  'city.a11y.contrastOff': 'Alto contraste',
  'city.a11y.contrastOn': 'Alto contraste em',
  'city.tour.welcome.title': 'Bem-vindo {city}',
  'city.tour.welcome.body': 'Esta cidade vive em seu próprio relógio. As pessoas acordam, trabalham, comem e dormem, observem ou não.',
  'city.tour.walk.title': 'Caminhar',
  'city.tour.walk.body': 'Toque em qualquer terreno aberto para caminhar até lá, e o seu robô encontra o seu próprio caminho pelas paredes e pelas portas.',
  'city.tour.talk.title': 'A falar.',
  'city.tour.talk.body': 'Toque em uma pessoa para ver o nome dela e caminhe até ela.',
  'city.tour.menu.title': 'Olhando mais de perto',
  'city.tour.menu.body': 'Em um computador, clique com o botão direito em qualquer coisa para ver o que você pode fazer lá, como ler um cartaz, sentar-se ou tomar um quarto.',
  'city.tour.map.title': 'O mapa mínimo',
  'city.tour.map.body': 'O pequeno mapa no canto mostra estradas, bairros e pessoas próximas.',
  'city.tour.panel.title': 'O seu painel',
  'city.tour.panel.body': 'O painel lateral lista as pessoas próximas, os lugares que você descobriu, suas missões, seu diário e muito mais.',
  'city.tour.keys.title': 'Movimentos',
  'city.tour.keys.body': 'O botão do teclado mostra todos os movimentos do robô.',
  'city.tour.done.title': 'Isso é tudo.',
  'city.tour.done.body': 'Aproveite {city}. Podes fazer esta visita novamente no painel lateral.',
  'city.tour.step': 'de {n} de {total}',
  'city.tour.next': 'Próximo .',
  'city.tour.back': 'De volta.',
  'city.tour.skip': 'Esqueça o passeio .',
  'city.tour.finish': 'Comece a explorar .',
  'city.tour.again': 'Faça o passeio pela cidade outra vez',
  'city.found.title': 'Locais descobertos',
  'city.found.count': 'de {n} de {total}',
  'city.found.none': 'Anda para um lugar para adicioná-lo aqui.',
  'city.found.new': 'Descoberto {place}',
  'city.board.open': 'Leia a placa de notas públicas',
  'city.board.hint': 'Notas deixadas aqui por outros viajantes. Encoste um curto de seu próprio, sem links, e até três de seus ficam de pé de vez.',
  'city.board.placeholder': 'Escreva uma breve nota para que os outros a encontrem',
  'city.board.pin': 'Encoste o bilhete.',
  'city.board.loading': 'Lendo o quadro...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Escreva a sua nota.',
  'city.board.err.signin': 'Inscreva-se para enfiar um bilhete.',
  'city.board.err.soon': 'Espera um pouco antes de colocar outra nota.',
  'city.board.err.bad': 'As anotações devem ser de texto simples de até 200 caracteres, sem links.',
  'city.board.err.down': 'Não se pode contactar o conselho agora.',
  'city.room.rent': 'Tome um quarto em {place}',
  'city.room.move': 'Mova o teu quarto para {place}',
  'city.room.yours': 'O teu quarto no {place}',
  'city.room.decorate': 'Ponha aqui alguma coisa.',
  'city.room.remove': 'Tirem-nos a {thing}',
  'city.room.leave': 'Entrega o teu quarto .',
  'city.room.full': 'O teu quarto não tem espaço para mais.',
  'city.room.pickTitle': 'Mobilize o seu quarto .',
  'city.room.pickHint': 'Escolha algo para colocar neste local, fica no teu quarto neste dispositivo.',
  'city.room.kind.rug': 'Um tapete tecido',
  'city.room.kind.candle': 'Uma vela',
  'city.room.kind.flowers': 'Um pote de flores',
  'city.room.kind.painting': 'Uma pintura',
  'city.room.kind.plant': 'Uma planta em pote',
  'city.room.kind.chest': 'Um pequeno peito .',
  'city.room.kind.lantern': 'Uma lanterna',
  'city.room.kind.books': 'Alguns livros .',
  'city.busk.lute': '{name} Põe-se uma melodia brilhante nas proximidades.',
  'city.busk.fiddle': '{name} Seja um carrinho animado perto',
  'city.busk.pipe': '{name} toca um ar lento nas proximidades',
  'city.busk.drum': '{name} Batem uma dança perto',
  'city.tail.label': 'Seguindo {name}',
  'city.tail.title': 'A seguir {name} durante o dia.',
  'city.tail.now': 'Agora, o que é? {activity} em {place}',
  'city.tail.unknown': 'Os seus planos para agora são desconhecidos.',
  'city.tail.next': 'Próximo: {place} em {time}, em {h} h {m} Minutos',
  'city.tail.trail': 'Traçado através: {places}',
  'city.tail.stop': 'Pára de seguir.',
  'city.pins.add': 'Adicionar um pin',
  'city.pins.tapMap': 'Toque no mapa para colocar o pin',
  'city.pins.walk': 'Caminha até este pin',
  'city.pins.note': 'Pin em {x}, {y}. Adicione uma nota',
  'city.pins.noteLabel': 'Nota de pin',
  'city.pins.remove': 'Remova este pin',
  'city.pins.here': 'Coloque este ponto no mapa.',
  'city.compass.north': 'Norte',
  'city.compass.at': 'x {x}, y {y}, piso {floor}',
  'city.door.prop': 'Põe a porta aberta.',
  'city.door.close': 'Deixe a porta fechar-se',
  'city.door.unlock': 'Desbloquei a porta.',
  'city.door.lock': 'Fecha a porta .',
  'city.books.browse': 'Explore a prateleira',
  'city.books.shelf': 'Estante em {place}',
  'city.books.book': 'Livro',
  'city.books.scroll': 'Rolo',
  'city.books.prev': 'Anterior',
  'city.books.back': 'De volta à prateleira .',
  'city.books.next': 'Próximo .',
  'city.books.page': 'Página {n} de {of}',
  'city.sign.readSign': 'Leia o sinal.',
  'city.sign.readPlaque': 'Leia a placa',
  'city.sign.sign': 'Um sinal pintado',
  'city.sign.plaque': 'Uma placa na porta',
  'city.district.entering': 'Entrando agora',
  'city.district.riverside': 'A margem do rio e os mercados baixos',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': 'Os Lanes',
  'city.district.monastery': 'O mosteiro',
  'city.district.castle': 'O Castelo',
  'city.district.drains': 'Os velhos esgotos',
  'city.district.farmlands': 'As terras agrícolas',
  'city.photo.enter': 'Modo de foto',
  'city.photo.hint': 'Modo de foto. Arrastar para olhar ao redor; tirar uma captura de tela para mantê-la.',
  'city.photo.leave': 'Deixar o modo de foto',
  'city.building.who': 'Que vive e trabalha em {place}',
  'city.building.live': 'Vive aqui.',
  'city.building.work': 'Funciona aqui.',
  'city.building.now': 'Agora dentro .',
  'city.building.rooms': 'Acelera . {list}.',
  'city.inspect.about': 'Sobre {name}',
  'city.inspect.close': 'Aproximado',
  'city.inspect.unknown': 'Ninguém pode dizer-te muito sobre {name}.',
  'city.inspect.home': 'Em casa',
  'city.inspect.work': 'Trabalho',
  'city.inspect.none': 'Nenhum conhecido',
  'city.inspect.today': 'Hoje em dia',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Segue . {name} durante o dia.',
  'city.overlay.label': 'Superposições de mapas',
  'city.overlay.crowd': 'Multidões',
  'city.overlay.light': 'Luz',
  'city.overlay.noise': 'Barulho',
  'city.bar.pop': '{n} Vive aqui.',
  'city.bar.out': '{n} Agora sai.',
  'city.bar.season.spring': 'Primavera',
  'city.bar.season.summer': 'Verão',
  'city.bar.season.autumn': 'Outono',
  'city.bar.season.winter': 'Inverno',
  'city.notebook.title': 'Ouviu e aprendeu',
  'city.notebook.all': 'Todos .',
  'city.notebook.heard': 'Ouvi dizer:',
  'city.notebook.learned': 'Aprendi',
  'city.notebook.search': 'Procura as notas.',
  'city.notebook.none': 'Ainda não se notou nada, ouça nas ruas e fale com as pessoas.',
  'city.ask.title': 'Pergunte por aí.',
  'city.ask.pick': '- Quem é que procura?',
  'city.ask.ask': 'Pergunte',
  'city.ask.passerby': 'Um transeúnte',
  'city.ask.nobody': 'Não há ninguém perto o suficiente para perguntar.',
  'city.ask.unseen': '{asker} Não viu {who} Sobre o dia de hoje.',
  'city.ask.here': '{asker} Diz: {who} Está perto. {place}.',
  'city.ask.go': 'Vai para {who}',
  'city.weather.clear': 'Céu claro',
  'city.weather.cloudy.light': 'Algumas nuvens.',
  'city.weather.cloudy.heavy': 'Cinza e nublada',
  'city.weather.rain.light': 'Chuva leve',
  'city.weather.rain.heavy': 'Chuva intensa',
  'city.weather.fog.light': 'Fumaça matinal',
  'city.weather.fog.heavy': 'Neblina espessa',
  'city.weather.snow.light': 'Neve leve',
  'city.weather.snow.heavy': 'Neve pesada',
  'city.lamplighter.name': 'Lamplighter',
  'city.lamplighter.lighting': 'acender as lâmpadas de rua',
  'city.lamplighter.dousing': 'apagar as lâmpadas de rua',
  'city.hourglass.title': 'Relógio de areia',
  'city.hourglass.stop': 'Parem o dia.',
  'city.hourglass.paused': 'O dia está parado.',
  'city.hourglass.resume': 'Vamos lá.',
  'city.seat.bench': 'banco',
  'city.seat.chair': 'cadeira',
  'city.seat.sit': 'Senta-te no {what}',
  'city.inside.crate': 'caixinha',
  'city.inside.barrel': 'Barril',
  'city.inside.title': 'Dentro do {what}',
  'city.inside.look': 'Olhem para dentro. {what}',
  'city.inside.holds': 'É o {fill}: {list}.',
  'city.factions.title': 'De pé na cidade',
  'city.factions.wary': 'Tem cuidado.',
  'city.factions.unknown': 'Desconhecido',
  'city.factions.noticed': 'Notado',
  'city.factions.trusted': 'Confiado',
  'city.factions.honored': 'Honrado .',
  'city.factions.done': 'Encomendas feitas: {n}.',
  'city.mail.title': 'Letras',
  'city.mail.none': 'Ainda não há cartas.',
  'city.mail.from': 'A partir de {name}',
  'city.mail.waiting': 'Esperando uma resposta de {names}.',
  'city.mail.nobody': 'Ajuda alguém com uma tarefa e podes escrever-lhe.',
  'city.mail.write': 'Escreva uma carta .',
  'city.mail.to': 'A quem?',
  'city.mail.subject': 'Subjetivos',
  'city.mail.body': 'A tua carta',
  'city.mail.send': 'Envia-o.',
  'city.mail.untitled': 'Algumas linhas .',
  'city.moth.title': 'A bandeja da Mariposa',
  'city.moth.trade': 'Faz-me um favor .',
  'city.moth.yours': 'Agora é seu.',
  'city.spy.title': 'Trabalho silencioso',
  'city.cut.skip': 'Salto',
  'city.party.title': 'Jogar juntos',
  'city.party.blurb': 'Comece uma festa e compartilhe o código com os amigos, todos se vêem em qualquer lugar da cidade, não apenas nos espaços compartilhados.',
  'city.party.start': 'Começa uma festa.',
  'city.party.codeLabel': 'Código do partido',
  'city.party.join': 'Junte-se',
  'city.party.bad': 'Um código de festa é de quatro a oito letras ou números.',
  'city.party.code': 'O teu código de festa é: {code}. Partilha com os amigos para que possam juntar-se.',
  'city.party.alone': 'Ninguém mais do seu partido está na cidade agora.',
  'city.party.here': 'Justo ao teu lado',
  'city.party.away': '{n} Pasos {dir}',
  'city.party.floor': '(pavimento) {n})',
  'city.party.go': 'Vai para',
  'city.party.leave': 'Saiam da festa.',
  'city.party.dir.east': 'leste',
  'city.party.dir.south-east': 'Sudeste',
  'city.party.dir.south': 'Sul',
  'city.party.dir.south-west': 'Sul-oeste',
  'city.party.dir.west': 'Ocidente',
  'city.party.dir.north-west': 'Norte-oeste',
  'city.party.dir.north': 'Norte',
  'city.party.dir.north-east': 'Norte-este',
  'city.print.title': 'Imprimir um edifício',
  'city.print.here': '{name}: {w} por {d} Células, pisos: {n}. Guarda-o como um STL para uma impressora 3D.',
  'city.print.none': 'Fique dentro ou ao lado de um edifício para guardá-lo como um STL para uma impressora 3D.',
  'city.print.model': 'Salvar STL, escala modelo (5 mm por célula)',
  'city.print.tabletop': 'Salvar STL, escala de mesa (1 polegada por célula)',
  'city.print.note': 'Muralhas, pisos, portas, escadas e janelas à medida que a cidade as desenha, em uma placa base para imprimir em uma peça.',
  'city.print.models': 'Figuras e adereços, prontos para impressão:',
  'city.print.busy': 'Preparando-se...',
  'city.print.model.figure': 'Figura de Walker, 28 mm numa base de 25 mm',
  'city.print.model.fountain': 'Fonte, 3 polegadas de diâmetro',
  'city.print.model.castle-wall': 'Seção da parede do castelo, 3 polegadas de comprimento',
  'city.editor.stl': 'Salvar STL',
  'city.editor.title': 'Editor de mapas da cidade',
  'city.editor.blurb': 'Pintem um mapa da cidade piso por piso: paredes, ruas, portas, água, escadas e lugares nomeados. O cheque abaixo lê-lo com o mesmo leitor de mapa que a cidade viva usa. Seu rascunho salva neste navegador; exportá-lo como um arquivo para guardar ou compartilhar.',
  'city.editor.name': 'Nome do mapa',
  'city.editor.tools': 'Ferramentas',
  'city.editor.tool.pen': 'Pênis',
  'city.editor.tool.rect': 'Bloco',
  'city.editor.tool.room': 'Quarto',
  'city.editor.tool.fill': 'Preencher',
  'city.editor.tool.spawn': 'Ponto de partida',
  'city.editor.tiles': 'Terreno',
  'city.editor.letter': 'Carta',
  'city.editor.placeName': 'Nome do local',
  'city.editor.addPlace': 'Adicionar espaço',
  'city.editor.placeBad': 'Um lugar precisa de uma letra e um nome.',
  'city.editor.floors': 'Pontos de construção',
  'city.editor.addFloor': 'Adicionar piso',
  'city.editor.map': 'Mapa',
  'city.editor.width': 'Largura',
  'city.editor.height': 'Altura',
  'city.editor.new': 'Novo mapa',
  'city.editor.undo': 'Desfeito',
  'city.editor.export': 'Exportação',
  'city.editor.import': 'Importação',
  'city.editor.loaded': 'Mapa carregada.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Verificação',
  'city.editor.ok': 'Está claro. {walk} Células abertas, {reach} Acessível desde o ponto de partida.',
  'city.editor.placeSpots': '{name}: {n} Células',
  'city.editor.canvas': 'Canvas de mapa',
  'city.spy.take': 'Tome-a.',
  'city.spy.again': 'Tenta outra vez.',
  'city.spy.drop': 'Deixa-o ir.',
  'city.spy.progress': '{n} Por cento lá.',
  'city.spy.carrying': 'Tens o bilhete.',
  'city.spy.underway': '- Está a caminho.',
  'city.spy.done': 'Já está.',
  'city.spy.failed': 'A última vez correu mal.',
  'city.menu.look': 'Olha para mim. {thing}',
  'city.menu.street': 'A rua',
  'city.menu.wall': 'Uma parede',
  'city.continue': 'Continuar',
  'city.goodbye': 'Adeus.',
  'city.board.title': 'Tabela de recompensas',
  'city.arrive.rooftops': 'Você se arrasta para os telhados, as ruas se abrem abaixo de você e as pranchas entre as casas rasgam sob os pés.',
  'city.arrive.museumRoof': 'Levas a tua velha ervilha para o telhado do museu e o Sunwalk Plaza se espalha por baixo de ti como um tabuleiro de jogos.',
  'city.crier.title': 'O lençol do gritador',
  'city.crier.today': 'Hoje é {name}.',
  'city.crier.tomorrow': '{name} É amanhã.',
  'city.crier.coming': '{name} em {n} dias.',
  'city.crier.stalls': 'Nas bancadas à primeira luz:',
  'city.crier.notices': '{n} Notícias no quadro de recompensa.',
  'city.crier.talk': 'Falamos da cidade:',
  'city.crier.now': 'O que está a acontecer na cidade agora:',
  'city.board.empty': 'Nada está preso hoje, verifique amanhã.',
  'city.board.posted': 'Publicado por: {name}.',
  'city.board.postedAt': 'Publicado por: {name}, agora em {place}.',
  'city.board.days': '{n} Querem uns dias.',
  'city.board.find': 'Encontre-os.',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'A falar com {name}',
  'city.journal': 'Jornal',
  'city.journalNone': 'Ainda nada escrito.',
  'city.quests': 'Arranhos e fios',
  'city.questNone': 'Ainda não, fala com as pessoas.',
  'city.rest': 'Reposo {n} minutos',
  'city.saves.title': 'Jogos salvos',
  'city.saves.slot': 'Localização {n}: {day} {time}, {place}',
  'city.saves.empty': 'Frota {n}: vazia',
  'city.saves.save': 'Salva aqui.',
  'city.saves.load': 'Carga',
  'city.saves.sure': 'Toque novamente para confirmar',
  'city.saves.hint': 'Uma salva mantém a cidade como está: onde você está, a hora, as pessoas, missões e cofres.',
  'city.restHint': 'Deixa passar o tempo, só podes descansar tanto em uma hora.',
  'city.bed.ask': 'Dorme bem. {bed}?',
  'city.bed.night': 'Passam-se oito horas enquanto dormes, e descansas segundo as regras do teu sistema de jogo.',
  'city.bed.sleep': 'Dormir',
  'city.bed.notNow': 'Não agora.',
  'city.bed.tired': 'Ainda não estás cansado, podes dormir de novo daqui a uns minutos. {n} horas.',
  'city.bed.asleep': 'A noite passa...',
  'city.bed.offer': 'Dorme aqui.',
  'city.vitals': 'Saúde',
  'city.bed.woke': 'Dormes lá dentro. {bed} e acordar em {time}. {change}',
  'city.bed.change': '{label}: {before} para {after}.',
  'city.bed.noRest': 'A Comissão {system} As regras não dão recuperação para descanso, por isso nada corre.',
  'city.bed.beds': 'Camas',
  'city.bed.demoRules': 'Regras para o teste de cama: {system}. Adicionar "rules=srd-5-2-1, zweihander ou rato para o endereço para tentar outro.',
  'city.messages': 'Notas',
  'city.rules': 'Sistema de jogos',
  'city.rulesNarrative': 'Não há regras: a cidade como uma história, escolha um sistema para ver todos em seus números.',
  'city.statsFor': 'Números para',
  'city.sparTitle': 'Batalha de prática',
  'city.sparA': 'Primeiro lutador',
  'city.sparB': 'Segundo lutador',
  'city.sparVs': 'contra',
  'city.sparRun': 'Combate',
  'city.sparNote': 'Uma manifestação neste sistema, ninguém na cidade está ferido.',
  'city.sparRound': 'Rondas {n}.',
  'city.zoomIn': 'Zoom em',
  'city.pivot.left': 'Girar a vista para a esquerda',
  'city.pivot.right': 'Girar a vista para a direita',
  'city.pivot.north': 'Olhar para o norte',
  'city.zoomOut': 'Zoom out',
  'city.centre': 'Centrem-se em mim.',
  'city.followOn': 'Continuem .',
  'city.followOff': 'Segue-o',
  'city.followOnHint': 'A câmera segue-te, desliga-a para a panela livremente.',
  'city.followOffHint': 'Toque em mim para voltares para ti.',
  'city.minimapShow': 'Mostrar o mapa',
  'city.minimapHide': 'Ocultar o mapa',
  'city.minimapOpen': 'Mapa da cidade, toque para abrir mais grande.',
  'city.minimapWalk': 'Mapa da cidade.',
  'city.minimapSmall': 'Diminuir o mapa',
  'city.minimapHint': 'Toque para andar lá.',
  'city.chatter.morning.1.a': 'Pão fresco nos fornos de esquina, se se apressar.',
  'city.chatter.morning.1.b': 'Cheirei-o duas ruas atrás.',
  'city.chatter.morning.2.a': 'Acordaste cedo.',
  'city.chatter.morning.2.b': 'Os sinos acordaram-me.',
  'city.chatter.morning.3.a': 'Os carrinhos entraram pelo portão?',
  'city.chatter.morning.3.b': 'Três deles, e um perdeu uma roda na ponte.',
  'city.chatter.morning.4.a': 'Frio esta manhã.',
  'city.chatter.morning.4.b': 'A névoa do rio vai desaparecer ao meio-dia.',
  'city.chatter.morning.5.a': '- Para onde vais?',
  'city.chatter.morning.5.b': 'O mercado, antes que as boas maçãs desapareçam.',
  'city.chatter.afternoon.1.a': 'Dia ocupado nas bancadas.',
  'city.chatter.afternoon.1.b': 'Estou muito ocupado, os meus pés desistiram de mim.',
  'city.chatter.afternoon.2.a': 'Viste o bronceador hoje?',
  'city.chatter.afternoon.2.b': 'Ele desceu à água há uma hora.',
  'city.chatter.afternoon.3.a': 'O sol é bom hoje.',
  'city.chatter.afternoon.3.b': 'Está a chover, sinto-o no joelho.',
  'city.chatter.afternoon.4.a': 'O que queria o vendedor de peixes para as anguínas?',
  'city.chatter.afternoon.4.b': 'Comprei repolhos em vez disso.',
  'city.chatter.afternoon.5.a': 'É um carro novo?',
  'city.chatter.afternoon.5.b': 'As rodas ainda gritam como a velha.',
  'city.chatter.evening.1.a': 'Já vais para casa?',
  'city.chatter.evening.1.b': 'O jantar não vai cozinhar por si mesmo.',
  'city.chatter.evening.2.a': 'As lâmpadas estão a acender-se.',
  'city.chatter.evening.2.b': 'Então estou atrasado outra vez.',
  'city.chatter.evening.3.a': 'Vais estar na taberna esta noite?',
  'city.chatter.evening.3.b': 'Se a minha mulher me permitir, sim.',
  'city.chatter.evening.4.a': 'É um longo dia.',
  'city.chatter.evening.4.b': 'Todos são, nesta época do ano.',
  'city.chatter.evening.5.a': 'Fechem as persianas esta noite.',
  'city.chatter.evening.5.b': 'Sempre o faço, mas o vento as agita de qualquer maneira.',
  'city.chatter.night.1.a': 'Quem vai lá?',
  'city.chatter.night.1.b': 'Deixa a lanterna para baixo.',
  'city.chatter.night.2.a': 'Devias estar a dormir.',
  'city.chatter.night.2.b': 'Tu também devias, amigo.',
  'city.chatter.night.3.a': 'Ouviste alguma coisa à beira da água?',
  'city.chatter.night.3.b': 'Gatos, são sempre gatos.',
  'city.chatter.night.4.a': 'Uma noite tranquila.',
  'city.chatter.night.4.b': 'Vamos continuar assim.',
  'city.chatter.any.1.a': 'Já ouviste as notícias?',
  'city.chatter.any.1.b': 'Há sempre notícias.',
  'city.chatter.any.2.a': 'Bom dia para ti.',
  'city.chatter.any.2.b': 'E para ti também.',
  'city.chatter.any.3.a': 'O meu primo jura que a antiga torre está assombrada.',
  'city.chatter.any.3.b': 'O teu primo jura muitas coisas.',
  'city.chatter.any.4.a': 'Os preços continuam a subir.',
  'city.chatter.any.4.b': 'E o meu salário continua parado.',
  'city.chatter.any.5.a': 'Cuidado com o poço.',
  'city.chatter.any.5.b': 'É tarde demais, obrigado.',
  'city.chatter.any.6.a': 'É o estranho que todos mencionam?',
  'city.chatter.any.6.b': 'Não olhes para mim, é grosseiro.',
  'city.chatter.any.7.a': 'Como está a tua mãe?',
  'city.chatter.any.7.b': 'Melhor, obrigado, ela voltou a repreender-me.',
  'city.chatter.any.8.a': 'Devo-te uma bebida, não devo?',
  'city.chatter.any.8.b': 'Dois, segundo a minha contagem.',
  'city.inventory.title': 'A tua mala',
  'city.inventory.subtitle': 'Montkelian Saco',
  'city.inventory.close': 'Fecha a mala',
  'city.inventory.tabs': 'Seções de embalagem',
  'city.inventory.tab.inventory': 'Inventário',
  'city.inventory.tab.journal': 'Jornal',
  'city.inventory.tab.map': 'Mapa',
  'city.inventory.empty': 'As coisas que encontrem durante as viagens serão guardadas nesses bolsos.',
  'city.inventory.slots': 'Bolsas',
  'city.inventory.slotEmpty': 'Bolso {n}, vazio',
  'city.inventory.slot.headgear': 'Capa de cabeça',
  'city.inventory.slot.helmet': 'Casco',
  'city.inventory.slot.hat': 'Chapéu',
  'city.inventory.slot.hood': 'Capuz',
  'city.inventory.slot.amulet': 'Amuleto',
  'city.inventory.slot.cloak': 'Capa',
  'city.inventory.slot.tabard': 'Tabard',
  'city.inventory.slot.pelt': 'Pelos',
  'city.inventory.slot.armor': 'Armadura',
  'city.inventory.slot.plate': 'Placas',
  'city.inventory.slot.robe': 'Roba',
  'city.inventory.slot.jerkin': '- Que idiota !',
  'city.inventory.slot.hide': 'Esconde-se',
  'city.inventory.slot.girdle': 'Girdle',
  'city.inventory.slot.belt': 'Cinturão',
  'city.inventory.slot.bracers': 'Fusões de aço',
  'city.inventory.slot.gloves': 'Guantes',
  'city.inventory.slot.mainHand': 'Main hand',
  'city.inventory.slot.offHand': 'Descontrolado',
  'city.inventory.slot.twoHand': 'Ambas as mãos.',
  'city.inventory.slot.sword': 'Espada',
  'city.inventory.slot.shield': 'Escudo',
  'city.inventory.slot.staff': 'Funcionários',
  'city.inventory.slot.focus': 'Concentre-se',
  'city.inventory.slot.ring': 'Anel',
  'city.inventory.slot.leggings': 'Leggings',
  'city.inventory.slot.greaves': 'Greaves',
  'city.inventory.slot.boots': 'Botas',
  'city.inventory.item.sword': 'Espada',
  'city.inventory.item.shield': 'Escudo',
  'city.inventory.item.knife': 'Cuchillo',
  'city.inventory.item.axe': 'Tesoura',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Cabo',
  'city.inventory.item.ring': 'Anel',
  'city.inventory.class.default': 'viajante',
  'city.inventory.class.fighter': 'Combatente',
  'city.inventory.class.paladin': 'Paladino',
  'city.inventory.class.berserker': 'Berserker',
  'city.inventory.class.wizard': 'Mágico',
  'city.inventory.class.rogue': 'Desobediente',
  'city.inventory.slotFree': 'Vazio',
  'city.inventory.gear': 'O que usas',
  'city.inventory.view': 'Mostra',
  'city.inventory.viewGear': 'Desgaste',
  'city.inventory.viewPockets': 'Bolsas',
  'city.inventory.avatarHint': 'Escolha um avatar diferente do menu, sob Avatar.',
  'city.inventory.soon.journal': 'O seu diário está em branco por enquanto.',
  'city.inventory.soon.map': 'O seu mapa dobrado será guardado aqui, marcado com os lugares onde você esteve.',
  'city.inventory.hint': 'Toque-se para abrir a mala',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Escolha o seu avatar',
  'city.avatar.robot': 'Robô',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladino',
  'city.avatarCloth': 'Roupas',
  'city.avatarClothHint': 'Capes e tabards balançar enquanto você se move',
  'city.soundOn': 'Ligue o som .',
  'city.soundOff': 'Desligue o som',
  'city.musicOn': 'Reproduzir música',
  'city.musicOff': 'Parem a música.',
  'city.walkSpeed': 'Velocidade',
  'city.walkSpeedLabel': 'Velocidade de caminhada',
  'city.walkSpeedValue': '{n}x',
  'city.me': '- Eu?',
  'city.quality': 'Qualidade',
  'city.qualityAuto': 'Auto ({tier})',
  'city.tier.low': 'Baixo',
  'city.tier.medium': 'Mediana',
  'city.tier.high': 'Alto',
  'city.robot.keys': 'Chaves de robô',
  'city.robot.title': 'Chaves de robô',
  'city.robot.intro': 'Apertar uma tecla, ou tocar aqui, e o seu robô faz isso para todos os próximos a vê-lo. É apenas para o show e não muda nada no jogo.',
  'city.robot.close': 'Aproximado',
  'city.robot.jumpNote': 'Pressão Espaço novamente enquanto estiver no ar para duplo salto.',
  'city.robot.spellNote': 'No modo de feitiço, 1, 2 e 3 são lançados em vez de ataques.',
  'city.robot.climbNote': 'As escadas mais próximas são as de cima e de baixo, ou a escada, ou o tubo de drenagem.',
  'city.robot.walkNote': 'W, A, S e D caminham para norte, oeste, sul e leste, passo a passo.',
  'city.robot.walk.north': 'Caminhar para norte',
  'city.robot.walk.west': 'Caminhar para o oeste',
  'city.robot.walk.south': 'Caminhar para sul',
  'city.robot.walk.east': 'Caminhar para leste',
  'city.stairs.label': 'Leva as escadas .',
  'city.stairs.up': 'Para cima.',
  'city.stairs.down': 'Para baixo.',
  'city.stairs.goUp': 'Vai um andar acima .',
  'city.stairs.goDown': 'Desça um andar .',
  'city.robot.toggleNote': 'Modo de arma, Modo de feitiço, Sneak, Dance e Fall para baixo permanecem até você pressioná-los novamente.',
  'city.robot.typing': 'As chaves não fazem nada enquanto você está digitando numa caixa.',
  'city.robot.inSpell': 'Modo de expressão: {act}',
  'city.robot.otherwise': 'Caso contrário: {act}',
  'city.robot.pad': 'Ações',
  'city.robot.padShow': 'Mostre o pad de ação',
  'city.robot.padHide': 'Esconde a almofada de ação',
  'city.robot.padTouch': '(para ecrãs táctiles)',
  'city.robot.noLadder': 'Não há escadas nem escadas perto',
  'city.robot.act.jump': 'Salto',
  'city.robot.act.double-jump': 'Salto duplo',
  'city.robot.act.dodge': '- Não .',
  'city.robot.act.block': 'Bloquear ou defender',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Modo de arma',
  'city.robot.act.spell-mode': 'Modo de feitiço',
  'city.robot.act.slash': 'Slash',
  'city.robot.act.thrust': 'Propulsão',
  'city.robot.act.flurry': 'Forrido',
  'city.robot.act.cast': 'Casting',
  'city.robot.act.cast-spell': 'Feitiço de lançamento',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': 'Pato .',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Cantem',
  'city.robot.act.dance': 'Dança .',
  'city.robot.act.barf': 'O que é?',
  'city.robot.act.fall': 'Caem ou levantam-se.',
  'city.robot.act.climb-up': 'Subam .',
  'city.robot.act.climb-down': 'Desça .',
  'city.robot.act.hurt': 'Dá um golpe .',
  'city.robot.act.kneel': 'Ajoelhar e ficar em pé',
  'city.robot.act.bow': 'Arco',
  'city.robot.act.cheer': 'Parabéns à vitória .',
  'city.panelShow': 'Painel de exibição',
  'city.phone.menu': 'Menu',
  'city.phone.close': 'Menu fechado',
  'city.phone.view': 'Mapa',
  'city.phone.sound': 'Som e ritmo',
  'city.phone.people': 'Encontre alguém.',
  'city.phone.more': 'Tudo o resto .',
  'city.phone.hint': 'Toque no chão para andar, toque numa pessoa para falar.',
  'city.phone.gotIt': 'Eu percebi.',
  'city.panelHide': 'Painel de ocultação',
  'city.canvasLabel3d': 'Mapa de {city} O painel lista todos e tudo aqui também.',
  'city.dock.label': 'Pessoas para encontrar',
  'city.dock.go': 'Caminha até lá. {name}',
  'city.dock.walking': 'A caminhar para {name}',
  'city.dock.toPlace': 'A caminhar para {name} em {place}',
  'city.dock.cancel': 'Toque no chão para parar',
  'city.rigDebug.open': 'Debug como {name} movimentos',
  'city.rigDebug.title': 'Debug do equipamento: {name}',
  'city.rigDebug.close': 'Aproximado',
  'city.rigDebug.move': 'Mova-te',
  'city.rigDebug.facing': 'Enfrentando',
  'city.rigDebug.allMoves': 'Todos os movimentos',
  'city.rigDebug.allFacings': 'Todas as faces',
  'city.rigDebug.cycling': 'Ciclismo, {s}s cada',
  'city.rigDebug.play': 'Jogar',
  'city.rigDebug.pause': 'Pausa',
  'city.rigDebug.back': 'Um passo para trás um quadro',
  'city.rigDebug.forward': 'Um passo para a frente , um quadro .',
  'city.rigDebug.speed': 'Velocidade',
  'city.rigDebug.hint': 'Pausa para passo a passo, toque para fora ou pressione Escape para fechar.',
  'city.rigDebug.anim.idle': 'Ociosidade',
  'city.rigDebug.anim.walk': 'Caminhar',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'Visualização',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Isométricos',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'em direcção {dir}',
  'city.rigDebug.cell': 'linha {row}, quadro {col}',
  'city.rigDebug.loading': 'Carregamento',
  'city.rigDebug.clip': 'Clip',
  'city.rigDebug.allClips': 'Todos os clips',
  'city.rigDebug.noClips': 'Sem clips',
  'city.rigDebug.layers': 'Mostra',
  'city.rigDebug.show.model': 'Modelo',
  'city.rigDebug.show.bones': 'Osso',
  'city.rigDebug.show.pieces': 'Peças',
  'city.rigDebug.boneCount': '{n} ossos',
  'city.rigDebug.no3d': 'A visão 3D não pôde começar nesta tela.',
  'city.rigDebug.hint3d': 'Arraste para virar a câmera, pausa para passo a passo, toque para fora ou pressione Escape para fechar.',
  'city.rigDebug.standIn': '{name} é apresentado no {body} O corpo está aqui até que o dela esteja pronto.',
  'city.rigDebug.archive': 'Arquivo',
  'city.rigDebug.archivePose': 'Previsão de posições: ver como {name} movimentos',
  'city.pose.open': 'Veja como . {name} movimentos',
  'city.pose.robot': 'Você (robô substitutivo)',
  'city.pose.you': 'Tu, tu.',
  'city.pose.see': 'Veja-os mover-se.',
  'city.pose.youTitle': 'Como se move?',
  'city.pose.openYou': 'Veja como se move.',
  'city.pose.title': 'Como é que {name} movimentos',
  'city.pose.allTitle': 'Todas as poses',
  'city.pose.all': 'Mostre todas as poses',
  'city.pose.one': '- Não . {name}',
  'city.pose.close': 'Aproximado',
  'city.pose.hint': 'Toque para fora para fechar',
  'city.pose.loading': 'Carregamento',
  'city.pose.anim.idle': 'Ociosidade',
  'city.pose.anim.walk': 'Caminhar',
  'city.pose.anim.talk': 'Fala',
  'city.pose.anim.sit': 'Senta-te.',
  'city.pose.anim.run': 'Correr',
  'city.pose.drag': 'Arrastar para virar',
  'city.pose.gait': 'Movimento',
  'city.pose.model': '{name} em 3D',
  'city.pose.dir.SW': 'em direcção ao sudoeste',
  'city.pose.dir.SE': 'em direcção ao sudeste',
  'city.pose.dir.NE': 'voltado para nordeste',
  'city.pose.dir.NW': 'em direcção ao noroeste',
  'city.demoLink': 'Abra a demonstração do renderizado',
  'city.demoTitle': 'Demonstração de renderização',
  'city.demoNote': 'Uma visualização local da cidade 3D com caminhantes.',
  'city.demoTime': 'Tempo do dia',
  'city.demoSeason': 'Temporada',
  'city.demoPlay': 'Faça o relógio .',
  'city.demoPause': 'Parem o relógio .',
  'city.demoTower': 'Torre de ensaio',
  'city.demoTowerNote': 'Um edifício de quatro andares para verificar o que você pode ver dentro. Dentro, os pisos acima de você são cortados e tudo o que você não pode ver de onde você está é cinza.',
  'city.demoGoTower': 'Caminha até a torre .',
  'city.demoFloor': '- A terra: {floor}',
  'city.demoFloor0': 'Terreno',
  'city.demoFloor1': '2o',
  'city.demoFloor2': 'Terceiro',
  'city.demoFloor3': 'Quarta',
  'city.demoFloor4': 'Tecto',
  'city.demoWindow': 'Janela do 3o andar',
  'city.demoRoom': 'Quarto interior do 3o andar',
  'city.demoUp': 'Para cima de um andar .',
  'city.demoDown': 'Para o chão .',
  'city.makeWay.polite': 'Desculpe-me.',
  'city.makeWay.gruff': 'Olha para onde andas.',
  'city.makeWay.immovable': 'Não me vou mexer.',
  'city.makeWay.busy': 'Cuidado com o caminho.',
  'cascade.seoTitle': 'Debugger de cascata',
  'cascade.title': 'Debugger de cascata',
  'cascade.intro': 'O lado do estilo vai do sistema até o diretor de arte. O lado herdeiro é toda a taxonomia, de cada raiz de fragmento até a espécie e as linhagens que sentam sobre eles. Abra qualquer linha para ler o texto completo.',
  'cascade.readOnly': 'Nada nesta tela pode alterar um pedido.',
  'cascade.fetchedAt': 'Leia a partir do conteúdo API em {time}',
  'cascade.refresh': 'Leia outra vez.',
  'cascade.loading': 'Lendo ambas as cascatas...',
  'cascade.error': 'Não consegui ler as cascas da API de conteúdo.',
  'cascade.forbidden': 'Esta tela é para administradores do site. Sua conta está conectada, mas não tem o papel de administrador.',
  'cascade.style.title': 'Cascada de estilo',
  'cascade.style.subtitle': 'Sistema, editor, linha de produtos, configuração, tipo de mídia, livro e diretor artístico.',
  'cascade.style.focus': 'Seguir a cadeia para',
  'cascade.style.counts': '{nodes} linhas de estilo, {edges} conexões, {media} modelos de mídia',
  'cascade.taxa.title': 'Cascada de herdeiros',
  'cascade.taxa.subtitle': 'Cada nó adiciona o seu próprio prompt a tudo o que herda dos nós acima dele.',
  'cascade.taxa.group': 'Grupos rápidos',
  'cascade.taxa.find': 'Encontre um taxão ou linhagem',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, um nome de linhagem...',
  'cascade.taxa.counts': '{taxa} Taxa, {prompts} Indicações de taxa, {lineages} linhagens',
  'cascade.taxa.shardCounts': '{taxa} Taxa, {prompts} linhas de ordem',
  'cascade.taxa.truncated': 'A API de conteúdo encerrou a lista de pedidos deste fragmento, por isso algumas linhas podem estar faltando aqui.',
  'cascade.taxa.emptyShards': 'Trastes sem taxa ainda: {names}',
  'cascade.taxa.orphans': 'Linhagens que apontam para um taxão não em nenhuma árvore',
  'cascade.taxa.noOwn': 'Não há nenhuma indicação para este grupo.',
  'cascade.taxa.inherits': 'Herdeiros de cima',
  'cascade.taxa.inheritsNothing': 'Nada herdado, é aqui que começa a cadeia.',
  'cascade.taxa.through': 'Composto através deste nó',
  'cascade.taxa.lineages': 'Linhagens desta espécie',
  'cascade.level.system': 'Sistema',
  'cascade.level.publisher': 'Editora',
  'cascade.level.product_line': 'Linha de produtos',
  'cascade.level.setting': 'Configuração',
  'cascade.level.media': 'Tipo de mídia',
  'cascade.level.book': 'Livro',
  'cascade.level.art_director': 'Diretor artístico',
  'cascade.empty.system': 'Não há linha de estilo de sistema nesta cadeia.',
  'cascade.empty.publisher': 'Ainda não existe nenhuma linha de estilo editora.',
  'cascade.empty.product_line': 'Não há linha de estilo de linha de produto nesta cadeia.',
  'cascade.empty.setting': 'Não há nenhuma linha de estilo nesta cadeia.',
  'cascade.empty.media': 'Não se aplicam modelos de tipo de mídia a esta cadeia.',
  'cascade.empty.book': 'Nenhuma linha de estilo de livro depende desta configuração.',
  'cascade.empty.art_director': 'Nenhum diretor de arte está ligado a esta cadeia.',
  'cascade.missing': 'Nível faltante',
  'cascade.others': 'Outras fileiras neste nível ({count})',
  'cascade.mediaSpeciesNote': '{count} Os modelos de espécies são apresentados no lado herdeiro, sob as linhagens.',
  'cascade.field.id': 'id',
  'cascade.field.scope': 'Ámbito de aplicação',
  'cascade.field.scopeId': 'Identificação de âmbito',
  'cascade.field.group': 'grupo',
  'cascade.field.mediaType': 'Tipo de mídia',
  'cascade.field.prompt': 'Pronto',
  'cascade.field.negative': 'Negativo',
  'cascade.field.defaults': 'padrões',
  'cascade.field.refs': 'imagens de referência',
  'cascade.field.chars': '{count} caracteres',
  'cascade.field.empty': 'vazio',
  'cascade.facet.art_direction': 'Núcleo',
  'cascade.facet.art_direction_character': 'Caráter',
  'cascade.facet.art_direction_scene': 'A cena',
  'cascade.facet.art_direction_interface': 'Interface',
  'cascade.facet.art_direction_cartography': 'Cartografia',
  'cascade.facet.art_direction_audiobook': 'Livro de áudio',
  'cascade.facet.art_direction_movie': 'Filme',
  'cascade.facet.art_direction_short': 'Curto',
  'cascade.facet.art_direction_tvshow': 'Programa de TV',
  'cascade.composed.title': 'Composto para {name}',
  'cascade.composed.layers': 'Capas, largas a estreitas',
  'cascade.composed.preview': 'Impressão de imagem composta',
  'cascade.composed.previewNote': 'Assemblada nesta tela a partir das linhas acima em ordem de cascata: estilo central, faceta de caracteres, modelos de mídia, traços de taxões, então a linha de impressão o gerador adiciona em código.',
  'cascade.composed.negative': 'Negativo composto',
  'cascade.composed.fromCode': 'Adicionado em código, não armazenado em nenhuma linha',
  'cascade.flags.duplicates': 'Disse duas vezes.',
  'cascade.flags.conflicts': 'Termos negativos que também aparecem no prompt',
  'cascade.flags.none': 'Sem frases repetidas e sem termos negativos que choquem com o aviso.',
  'cascade.flags.in': 'em {sources}',
  'cascade.source.styleCore': 'Core de estilo',
  'cascade.source.styleCharacter': 'Características de estilo',
  'cascade.source.media': 'Modelo de mídia, {scope}',
  'cascade.source.taxon': 'Taxo {rank} {value}',
  'cascade.source.printSafe': 'Linha de impressão (código)',
  'cascade.rank.domain': 'domínio',
  'cascade.rank.kingdom': 'reino',
  'cascade.rank.phylum': 'Filo',
  'cascade.rank.class': 'classe',
  'cascade.rank.ordem': 'ordem',
  'cascade.rank.family': 'família',
  'cascade.rank.genus': 'género',
  'cascade.rank.species': 'espécies',
  'cascade.rank.shard': 'Orifício',
}
